export default function sanitizeReturnTo(input: unknown): string {
  const value = typeof input === 'string' ? input : '/'

  if (
    value.includes('\\') ||
    [...value].some((character) => {
      const code = character.charCodeAt(0)
      return code <= 31 || code === 127
    })
  ) {
    return '/'
  }
  if (!value.startsWith('/')) return '/'
  if (value.startsWith('//')) return '/'

  return value
}